export default __webpack_public_path__ + "static/media/bottom.5f736653.svg";